import { $fetch, $post, $put } from '@/services/axios';

export function fetch(params) {
  return $fetch(`customer/message/templates`, params);
}

export function validate(model) {
  return $post(`customer/message/template/validate`, model);
}

export function create(model) {
  return $put(`customer/message/template`, model);
}

export function update(model) {
  return $post(`customer/message/template/${model.id}`, model);
}
